export const CREATE_VACCINE_REQUEST = 'CREATE_VACCINE_REQUEST'
export const CREATE_VACCINE_SUCCESS = 'CREATE_VACCINE_SUCCESS'
export const CREATE_VACCINE_FAIL = 'CREATE_VACCINE_FAIL'
export const CREATE_VACCINE_RESET = 'CREATE_VACCINE_RESET'


export const LIST_VACCINE_REQUEST = 'LIST_VACCINE_REQUEST'
export const LIST_VACCINE_SUCCESS = 'LIST_VACCINE_SUCCESS'
export const LIST_VACCINE_FAIL = 'LIST_VACCINE_FAIL'
export const LIST_VACCINE_RESET = 'LIST_VACCINE_RESET'

export const DELETE_VACCINE_REQUEST = 'DELETE_VACCINE_REQUEST'
export const DELETE_VACCINE_SUCCESS = 'DELETE_VACCINE_SUCCESS'
export const DELETE_VACCINE_FAIL = 'DELETE_VACCINE_FAIL'

export const UPDATE_VACCINE_REQUEST = 'UPDATE_VACCINE_REQUEST'
export const UPDATE_VACCINE_SUCCESS = 'UPDATE_VACCINE_SUCCESS'
export const UPDATE_VACCINE_FAIL = 'UPDATE_VACCINE_FAIL'
export const UPDATE_VACCINE_RESET = 'UPDATE_VACCINE_RESET'


export const DETAILS_VACCINE_REQUEST = 'DETAILS_VACCINE_REQUEST'
export const DETAILS_VACCINE_SUCCESS = 'DETAILS_VACCINE_SUCCESS'
export const DETAILS_VACCINE_FAIL = 'DETAILS_VACCINE_FAIL'


export const LIST_TYPE_ENUMS_REQUEST = 'LIST_TYPE_ENUMS_REQUEST'
export const LIST_TYPE_ENUMS_SUCCESS = 'LIST_TYPE_ENUMS_SUCCESS'
export const LIST_TYPE_ENUMS_FAIL = 'LIST_TYPE_ENUMS_FAIL'
export const LIST_TYPE_ENUMS_RESET = 'LIST_TYPE_ENUMS_RESET'